import axios from 'axios';

export const $getGohomeData = (empNo, date) => {
  return axios.get(`/api/gohome?empNo=${empNo}&date=${date}`)
}

export const $getGohomeDataMonthlyAll = (empNo, date) => {
  return axios.get(`/api/gohome/calendar?empNo=${empNo}&date=${date}`)
}

export const $saveHoliday = (empNo, date, type) => {
  return axios.put(`/api/holiday/?empNo=${empNo}&date=${date}&type=${type}`)
}

export const $saveSelfExceptTime = (empNo, date, hour, minute) => {
  return axios.post(`/api/excepttime/?empNo=${empNo}&date=${date}&hour=${hour}&minute=${minute}`)
}

export const $deleteSelfExceptTime = (empNo, date, hour, minute) => {
  return axios.delete(`/api/excepttime/?empNo=${empNo}&date=${date}`)
}

export const $getMonthlyWorkTime = (empNo, date) => {
  return axios.post(`/api/monthly/?empNo=${empNo}&date=${date}`)
}

export const $getMonthlyRequiredWorkTime = (date) => {
  return axios.get(`/api/monthly/duty?date=${date}`)
}

export const $saveModifyTime = (empNo, date, type, time) => {
  return axios.put(`/api/modifiedtime/?empNo=${empNo}&date=${date}&type=${type}&time=${time}`)
}

export const $deleteModifyTime = (empNo, date, type) => {
  return axios.delete(`/api/modifiedtime/?empNo=${empNo}&date=${date}&type=${type}`)
}

export const $getWorkHomePart = (from, to) => {
  return axios.get(`/api/workhomepart/?from=${from}&to=${to}`)
}



// WEBPACK FOOTER //
// ./src/_api_/gohomeAPI.js